/**
 * Validate email
 * @param {string} email
 * @return {boolean|null}
 */
export const validateEmail = email => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    )
}

/**
 * Validate name
 * @param {string} name
 * @return {boolean}
 */
export const validateName = name => {
  return /^[a-zA-Z_&.-\s]*$/.test(name)
}
